import { render } from "./meetingRequests.vue?vue&type=template&id=60a87bf7&scoped=true&ts=true"
import script from "./meetingRequests.vue?vue&type=script&lang=ts"
export * from "./meetingRequests.vue?vue&type=script&lang=ts"

import "./meetingRequests.vue?vue&type=style&index=0&id=60a87bf7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a87bf7"]])

export default __exports__